import { sync } from "vuex-router-sync";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./main.scss";
import Directives from "./services/directives";

import prototypes from "./services/prototypes";

Vue.use(prototypes);
Vue.directive("click-outside", Directives.clickOutside());
Vue.config.productionTip = false;

sync(store, router);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
